export const tokenAddress = "0xad09104083d182d067cae2a123c6f1b052d2ea42";
export const presaleAddress = "0x124C198e7a4872B8BDFE2b8f151100B107E85f66";
